<app-accessories-alerts-list></app-accessories-alerts-list>